// extracted by mini-css-extract-plugin
export default {"new-notification-dot":"NotificationList_new-notification-dot__VDO2y","notification-list-item":"NotificationList_notification-list-item__UMrqu"};